import isomorphicRoute from '@client/helperComponents/isomorphicRoute';
import ErrorLoadingRouteChunk from '@client/containers/errorLoadingRouteChunk/ErrorLoadingRouteChunk';
import Loader from '@client/components/loader/Loader';
import { withRestrictions } from '@client/helperComponents/restrict/withRestrictions';

const options = {
  error: ErrorLoadingRouteChunk,
  loading: Loader,
};

export const routesCreateIF = {
  path: '/skapa/insamling',
  componentPath: 'pages/createIFPage/CreateIFPage',
  Component: withRestrictions({ shouldBeLoggedIn: true })(
    isomorphicRoute(() => import('pages/createIFPage/CreateIFPage'), options),
    isomorphicRoute(() => import('pages/homePage/HomePage'), options)
  ),
};
